import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';

import AimingShape from './assets/AimingShape.svg';
import Archived from './assets/Archived.svg';
import ArrowLeftBig from './assets/ArrowLeftBig.svg';
import ArrowRightBig from './assets/ArrowRightBig.svg';
import ArrowRightThin from './assets/ArrowRightThin.svg';
import AudioPause from './assets/AudioPause.svg';
import AudioPlay from './assets/AudioPlay.svg';
import AuditoryColoredShape from './assets/AuditoryColoredShape.svg';
import AuditoryShape from './assets/AuditoryShape.svg';
import BannerShape from './assets/BannerShape.svg';
import BellShape from './assets/BellShape.svg';
import BigRows from './assets/BigRows.svg';
import BudgetShape from './assets/BudgetShape.svg';
import BurgerShape from './assets/BurgerShape.svg';
import CalendarShape from './assets/CalendarShape.svg';
import ContentPromotionCollectionShape from './assets/campaigns/contentPromotionCollectionTypeShape.svg';
import ContentPromotionShape from './assets/campaigns/contentPromotionTypeShape.svg';
import ContentPromotionVideoShape from './assets/campaigns/contentPromotionVideoTypeShape.svg';
import CPCVideoTypeShape from './assets/campaigns/cpcVideoTypeShape.svg';
import CPMAudioTypeShape from './assets/campaigns/cpmAudioTypeShape.svg';
import CPMBannerInMetroShape from './assets/campaigns/cpmBannerInMetroShape.svg';
import CPMBannerTypeShape from './assets/campaigns/cpmBannerTypeShape.svg';
import CPMDealsTypeShape from './assets/campaigns/cpmDealsTypeShape.svg';
import CPMFrontpageTypeShape from './assets/campaigns/cpmFrontpageTypeShape.svg';
import CPMGeoproductTypeShape from './assets/campaigns/cpmGeoproductTypeShape.svg';
import CPMIndoorTypeShape from './assets/campaigns/cpmIndoorTypeShape.svg';
import CPMOutdoorTypeShape from './assets/campaigns/cpmOutdoorTypeShape.svg';
import CPMPriceTypeShape from './assets/campaigns/cpmPriceTypeShape.svg';
import DynamicTypeShape from './assets/campaigns/dynamicTypeShape.svg';
import ImageAdTypeShape from './assets/campaigns/imageAdTypeShape.svg';
import AutobudgetTypeShape from './assets/campaigns/internalAutobudgetTypeShape.svg';
import DistribTypeShape from './assets/campaigns/internalDistribTypeShape.svg';
import FreeTypeShape from './assets/campaigns/internalFreeTypeShape.svg';
import MCBannerTypeShape from './assets/campaigns/mcbannerTypeShape.svg';
import MobileContentTypeShape from './assets/campaigns/mobileContentTypeShape.svg';
import PerformanceTypeShape from './assets/campaigns/performanceTypeShape.svg';
import TextTypeShape from './assets/campaigns/textTypeShape.svg';
import ExpandShape from './assets/canvas/ExpandShape.svg';
import ExportShape from './assets/canvas/ExportShape.svg';
import MoreShape from './assets/canvas/MoreShape.svg';
import PackshotShape from './assets/canvas/PackshotShape.svg';
import Trash from './assets/canvas/Trash.svg';
import CheckShape from './assets/CheckShape.svg';
import CloseBadge from './assets/CloseBadge.svg';
import CloseShape from './assets/CloseShape.svg';
import CloseTagShape from './assets/CloseTagShape.svg';
import ConstructorShape from './assets/ConstructorShape.svg';
import Copy from './assets/Copy.svg';
import CopyId from './assets/CopyId.svg';
import CopyNew from './assets/CopyNew.svg';
import CropShape from './assets/CropShape.svg';
import CrossShape from './assets/CrossShape.svg';
import CurrentLocation from './assets/CurrentLocation.svg';
import Device from './assets/device.svg';
import DirectLogoEnShape from './assets/DirectLogoEnShape.svg';
import DirectLogoRuShape from './assets/DirectLogoRuShape.svg';
import Dots from './assets/Dots.svg';
import DoubleArrow from './assets/DoubleArrow.svg';
import DownArrow from './assets/DownArrow.svg';
import Download from './assets/Download.svg';
import DraftShape from './assets/DraftShape.svg';
import DragShape from './assets/DragShape.svg';
import DuplicateShape from './assets/DuplicateShape.svg';
import EditShape from './assets/EditShape.svg';
import EnterShape from './assets/EnterShape.svg';
import ExcludedValue from './assets/ExcludedValue.svg';
import EyeShape from './assets/Eye.svg';
import Feedback from './assets/Feedback.svg';
import Filter from './assets/Filter.svg';
import ForwardBack from './assets/ForwardBack.svg';
import FullText from './assets/FullText.svg';
import GrayOvalShape from './assets/GrayOvalShape.svg';
import Help from './assets/Help.svg';
import ImageShape from './assets/ImageShape.svg';
import IncludedValue from './assets/IncludedValue.svg';
import InfoRedShape from './assets/InfoRedShape.svg';
import InfoShape from './assets/InfoShape.svg';
import KeywodsShape from './assets/KeywodsShape.svg';
import Lamp from './assets/Lamp.svg';
import LampWithCircle from './assets/LampWithCircle.svg';
import Layers from './assets/LayersShape.svg';
import LeftArrowShape from './assets/LeftArrowShape.svg';
import Link2 from './assets/Link2Shape.svg';
import Link from './assets/LinkShape.svg';
import Location from './assets/Location.svg';
import MagicWandShape from './assets/MagicWandShape.svg';
import MailShape from './assets/MailShape.svg';
import MapPin from './assets/MapPin.svg';
import MapPlaceMark from './assets/MapPlaceMark.svg';
import MetrikaColoredShape from './assets/MetrikaColoredShape.svg';
import MetrikaShape from './assets/MetrikaShape.svg';
import MinusShape from './assets/MinusShape.svg';
import MoneyShape from './assets/MoneyShape.svg';
import NoAudio from './assets/NoAudio.svg';
import NoImage from './assets/NoImage.svg';
import NoVideo from './assets/NoVideo.svg';
import OutdoorBillBoard from './assets/OutdoorBillBoard.svg';
import OutdoorCitiFormat from './assets/OutdoorCitiFormat.svg';
import OutdoorDevice from './assets/OutdoorDevice.svg';
import OutdoorMediaF from './assets/OutdoorMediaF.svg';
import OutdoorSuperSite from './assets/OutdoorSuperSite.svg';
import PlusShape from './assets/PlusShape.svg';
import PolygonIcon from './assets/PolygonIcon.svg';
import PreferredDealShape from './assets/PreferredDealShape.svg';
import Group from './assets/preview-types/Group.svg';
import Long from './assets/preview-types/Long.svg';
import Mobile from './assets/preview-types/Mobile.svg';
import RSYA from './assets/preview-types/RSYA.svg';
import Short from './assets/preview-types/Short.svg';
import PrivateMarketplaceShape from './assets/PrivateMarketplaceShape.svg';
import Question from './assets/Question.svg';
import Refresh from './assets/Refresh.svg';
import RejectShape from './assets/RejectShape.svg';
import ReplaceShape from './assets/ReplaceShape.svg';
import RevertShape from './assets/RevertShape.svg';
import RocketShape from './assets/RocketShape.svg';
import ScreensTypeBoth from './assets/screen-types/screensTypeBoth.svg';
import ScreensTypeHorizont from './assets/screen-types/screensTypeHorizont.svg';
import ScreensTypeVertical from './assets/screen-types/screensTypeVert.svg';
import Search from './assets/Search.svg';
import SettingsShape from './assets/SettingsShape.svg';
import Share from './assets/ShareShape.svg';
import ShortText from './assets/ShortText.svg';
import SidebarCampaigns from './assets/sidebar/SidebarCampaigns.svg';
import SidebarEdit from './assets/sidebar/SidebarEdit.svg';
import SidebarInfo from './assets/sidebar/SidebarInfo.svg';
import SidebarLibrary from './assets/sidebar/SidebarLibrary.svg';
import SidebarRecommendations from './assets/sidebar/SidebarRecommendations.svg';
import SidebarReports from './assets/sidebar/SidebarReports.svg';
import SidebarTools from './assets/sidebar/SidebarTools.svg';
import SiteShape from './assets/SiteShape.svg';
import SmallRows from './assets/SmallRows.svg';
import Sort from './assets/Sort.svg';
import SplitInfo from './assets/SplitInfoShape.svg';
import StarShape from './assets/StarShape.svg';
import StatisticsShape from './assets/StatisticsShape.svg';
import StatusEnded from './assets/status/icon_status_ended.svg';
import StatusPaused from './assets/status/icon_status_paused.svg';
import StatusPending from './assets/status/icon_status_pending.svg';
import StatusRunning from './assets/status/icon_status_running.svg';
import StatusStopped from './assets/status/icon_status_stopped.svg';
import StatusStoppedOk from './assets/status/icon_status_stopped_ok.svg';
import StatusStoppedWarn from './assets/status/icon_status_stopped_warn.svg';
import TargetShape from './assets/TargetShape.svg';
import TickShape from './assets/TickShape.svg';
import TimeShape from './assets/TimeShape.svg';
import TrashbinShape from './assets/TrashbinShape.svg';
import Turbo from './assets/TurboShape.svg';
import UpArrow from './assets/UpArrow.svg';
import UploadShape from './assets/Upload.svg';
import VerticalArrowShape from './assets/VerticalArrowShape.svg';
import VideoPlayShape from './assets/VideoPlayShape.svg';
import visionLogoShape from './assets/vision/LogoShape.svg';
import visionTextRuShape from './assets/vision/ru/TextShape.svg';
import WalletShape from './assets/WalletShape.svg';
import Warning from './assets/Warning.svg';
import WhiteOvalShape from './assets/WhiteOvalShape.svg';
import WwwShape from './assets/WwwShape.svg';
import YellowOvalShape from './assets/YellowOvalShape.svg';
import ZoomShape from './assets/Zoom.svg';
import './Shape2.css';

export enum Shape2Padding {
    s = 's',
    m = 'm',
    l = 'l'
}

export enum Shape2Theme {
    default = 'default',
    light = 'light'
}

export enum Shape2Tone {
    clear = 'clear',
    dark = 'dark',
    white = 'white',
    yellow = 'yellow',
    red = 'red',
    blue = 'blue',
    grey = 'grey',
    darkGrey = 'dark-grey',
    green = 'green'
}

export enum Shape2Icon {
    copyId = 'copyId',
    currentLocation = 'currentLocation',
    location = 'location',
    search = 'search',
    arrowLeftBig = 'arrowLeftBig',
    arrowRightBig = 'arrowLRightBig',
    arrowRightThin = 'arrowLRightThin',
    aiming = 'aiming',
    archived = 'archived',
    calendar = 'calendar',
    crop = 'crop',
    check = 'check',
    cross = 'cross',
    device = 'device',
    enter = 'enter',
    eye = 'eye',
    info = 'info',
    infoRed = 'infoRed',
    reject = 'reject',
    time = 'time',
    draft = 'draft',
    statistics = 'statistics',
    leftArrow = 'left-arrow',
    help = 'help',
    minus = 'minus',
    plus = 'plus',
    drag = 'drag',
    duplicate = 'duplicate',
    close = 'close',
    vision = 'vision',
    visionRuText = 'visionRuText',
    closeTag = 'closeTag',
    constructor = 'constructor',
    preferredDeal = 'preferredDeal',
    privateMarketplace = 'privateMarketplace',
    settings = 'settings',
    tick = 'tick',
    trashbin = 'trashbin',
    replace = 'replace',
    verticalArrow = 'verticalArrow',
    download = 'download',
    lamp = 'lamp',
    lampWithCircle = 'lampWithCircle',
    edit = 'edit',
    directLogoRu = 'directLogoRu',
    directLogoEn = 'directLogoEn',
    burger = 'burger',
    wallet = 'wallet',
    link = 'link',
    link2 = 'link2',
    layers = 'layers',
    turbo = 'turbo',
    copy = 'copy',
    copyNew = 'copyNew',
    metrika = 'metrika',
    metrikaColored = 'metrikaColored',
    mail = 'mail',
    money = 'money',
    site = 'site',
    star = 'star',
    target = 'target',
    www = 'www',
    keywods = 'keywods',
    image = 'image',
    budget = 'budget',
    auditory = 'auditory',
    auditoryColored = 'auditoryColored ',
    banner = 'banner',
    videoPlay = 'videoPlay',
    mapPin = 'mapPin',
    mapPlaceMark = 'mapPlaceMark',
    // Campaign icon keys
    typeText = 'typeText',
    typeInternalDistrib = 'internalDistrib',
    typeInternalFree = 'internalFree',
    typeInternalAutobudget = 'typeInternalAutobudget',
    typePerformance = 'typePerformance',
    typeDynamic = 'typeDynamic',
    typeMobileContent = 'typeMobileContent',
    typeMCBanner = 'typeMCBanner',
    typeCPMBanner = 'typeCPMBanner',
    typeCPMBannerInMetro = 'typeCPMBannerInMetro',
    typeCPMAudio = 'typeCPMAudio',
    typeCPMOutdoor = 'typeCPMOutdoor',
    typeCPMIndoor = 'typeCPMIndoor',
    typeCPMCampaign = 'typeCPMCampaign',
    typeCPMPriceCampaign = 'typeCPMPriceCampaign',
    typeCPMDeals = 'typeCPMDEALS',
    typeImageAd = 'typeImageAd',
    typeCPCVideo = 'typeCPCVideo',
    typeContentPromotion = 'typeContentPromotion',
    typeContentPromotionCollection = 'typeContentPromotionCollection',
    typeContentPromotionVideo = 'typeContentPromotionVideo',
    typeCPMFrontpage = 'typeCPMFrontpage',
    typeCPMGeoproduct = 'typeCPMGeoproduct',
    magicWand = 'magicWand',
    noImage = 'NoImage',
    noVideo = 'noVideo',
    noAudio = 'noAudio',
    doubleArrow = 'doubleArrow',
    question = 'question',
    smallRows = 'smallRows',
    bigRows = 'bigRows',
    sort = 'sort',
    feedback = 'feedback',
    filter = 'filter',
    dots = 'dots',
    warning = 'warning',
    closeBadge = 'closeBadge',
    splitInfo = 'splitInfo',
    bellShape = 'bellShape',
    share = 'share',
    group = 'group',
    long = 'long',
    fullText = 'fullText',
    shortText = 'shortText',
    mobile = 'mobile',
    rsya = 'rsya',
    rocket = 'rocket',
    short = 'short',
    sidebarCampaigns = 'sidebarCampaigns',
    sidebarInfo = 'sidebarInfo',
    sidebarLibrary = 'sidebarLibrary',
    sidebarRecommendations = 'sidebarRecommendations',
    sidebarReports = 'sidebarReports',
    sidebarTools = 'sidebarTools',
    sidebarEdit = 'sidebarEdit',
    statusRunning = 'statusRunning',
    statusPending = 'statusPending',
    statusStopped = 'statusStopped',
    statusStoppedOk = 'statusStoppedOk',
    statusStoppedWarn = 'statusStoppedWarn',
    statusPaused = 'statusPaused',
    statusEnded = 'statusEnded',
    outdoorBillBoard = 'outdoorBillBoard',
    outdoorCitiFormat = 'outdoorCitiFormat',
    outdoorMediaF = 'outdoorMediaF',
    outdoorSuperSite = 'OutdoorSuperSite',
    outdoorDevice = 'outdoorDevice',
    yellowOval = 'yellowOval',
    whiteOval = 'whiteOval',
    grayOval = 'grayOval',
    polygon = 'polygon',
    revert = 'revert',
    excludedValue = 'excludedValue',
    includedValue = 'includedValue',
    downArrow = 'downArrow',
    upArrow = 'upArrow',
    audioPlay = 'audioPlay',
    audioPause = 'audioPause',
    expand = 'expand',
    more = 'more',
    packshot = 'packshot',
    export = 'export',
    trash = 'trash',
    // screen types icons
    screenTypeBoth = 'screenTypeBoth',
    screenTypeHorizontal = 'screenTypeHorizontal',
    screenTypeVertical = 'screenTypeVertical',
    refresh = 'refresh',
    upload = 'upload',
    forwardBack = 'forwardBack',
    zoom = 'zoom'
}

const svgIcons = {
    [Shape2Icon.forwardBack]: ForwardBack,
    [Shape2Icon.search]: Search,
    [Shape2Icon.arrowRightBig]: ArrowRightBig,
    [Shape2Icon.arrowRightThin]: ArrowRightThin,
    [Shape2Icon.arrowLeftBig]: ArrowLeftBig,
    [Shape2Icon.aiming]: AimingShape,
    [Shape2Icon.archived]: Archived,
    [Shape2Icon.rocket]: RocketShape,
    [Shape2Icon.polygon]: PolygonIcon,
    [Shape2Icon.calendar]: CalendarShape,
    [Shape2Icon.cross]: CrossShape,
    [Shape2Icon.reject]: RejectShape,
    [Shape2Icon.statistics]: StatisticsShape,
    [Shape2Icon.time]: TimeShape,
    [Shape2Icon.draft]: DraftShape,
    [Shape2Icon.crop]: CropShape,
    [Shape2Icon.device]: Device,
    [Shape2Icon.edit]: EditShape,
    [Shape2Icon.enter]: EnterShape,
    [Shape2Icon.eye]: EyeShape,
    [Shape2Icon.info]: InfoShape,
    [Shape2Icon.infoRed]: InfoRedShape,
    [Shape2Icon.leftArrow]: LeftArrowShape,
    [Shape2Icon.minus]: MinusShape,
    [Shape2Icon.plus]: PlusShape,
    [Shape2Icon.settings]: SettingsShape,
    [Shape2Icon.trashbin]: TrashbinShape,
    [Shape2Icon.replace]: ReplaceShape,
    [Shape2Icon.close]: CloseShape,
    [Shape2Icon.closeTag]: CloseTagShape,
    [Shape2Icon.vision]: visionLogoShape,
    [Shape2Icon.visionRuText]: visionTextRuShape,
    [Shape2Icon.constructor]: ConstructorShape,
    [Shape2Icon.drag]: DragShape,
    [Shape2Icon.duplicate]: DuplicateShape,
    [Shape2Icon.preferredDeal]: PreferredDealShape,
    [Shape2Icon.privateMarketplace]: PrivateMarketplaceShape,
    [Shape2Icon.screenTypeBoth]: ScreensTypeBoth,
    [Shape2Icon.screenTypeHorizontal]: ScreensTypeHorizont,
    [Shape2Icon.screenTypeVertical]: ScreensTypeVertical,
    [Shape2Icon.settings]: SettingsShape,
    [Shape2Icon.tick]: TickShape,
    [Shape2Icon.verticalArrow]: VerticalArrowShape,
    [Shape2Icon.download]: Download,
    [Shape2Icon.drag]: DragShape,
    [Shape2Icon.directLogoRu]: DirectLogoRuShape,
    [Shape2Icon.directLogoEn]: DirectLogoEnShape,
    [Shape2Icon.burger]: BurgerShape,
    [Shape2Icon.wallet]: WalletShape,
    [Shape2Icon.lamp]: Lamp,
    [Shape2Icon.lampWithCircle]: LampWithCircle,
    [Shape2Icon.link]: Link,
    [Shape2Icon.help]: Help,
    [Shape2Icon.link2]: Link2,
    [Shape2Icon.layers]: Layers,
    [Shape2Icon.turbo]: Turbo,
    [Shape2Icon.copy]: Copy,
    [Shape2Icon.copyNew]: CopyNew,
    [Shape2Icon.metrika]: MetrikaShape,
    [Shape2Icon.metrikaColored]: MetrikaColoredShape,
    [Shape2Icon.mail]: MailShape,
    [Shape2Icon.money]: MoneyShape,
    [Shape2Icon.site]: SiteShape,
    [Shape2Icon.star]: StarShape,
    [Shape2Icon.target]: TargetShape,
    [Shape2Icon.www]: WwwShape,
    [Shape2Icon.keywods]: KeywodsShape,
    [Shape2Icon.image]: ImageShape,
    [Shape2Icon.includedValue]: IncludedValue,
    [Shape2Icon.excludedValue]: ExcludedValue,
    [Shape2Icon.downArrow]: DownArrow,
    [Shape2Icon.upArrow]: UpArrow,
    [Shape2Icon.budget]: BudgetShape,
    [Shape2Icon.auditory]: AuditoryShape,
    [Shape2Icon.auditoryColored]: AuditoryColoredShape,
    [Shape2Icon.banner]: BannerShape,
    [Shape2Icon.videoPlay]: VideoPlayShape,
    [Shape2Icon.mapPin]: MapPin,
    [Shape2Icon.check]: CheckShape,
    [Shape2Icon.mapPlaceMark]: MapPlaceMark,
    [Shape2Icon.yellowOval]: YellowOvalShape,
    [Shape2Icon.whiteOval]: WhiteOvalShape,
    [Shape2Icon.grayOval]: GrayOvalShape,

    // Campaign icons
    [Shape2Icon.typeText]: TextTypeShape,
    [Shape2Icon.typeInternalFree]: FreeTypeShape,
    [Shape2Icon.typeInternalDistrib]: DistribTypeShape,
    [Shape2Icon.typeInternalAutobudget]: AutobudgetTypeShape,
    [Shape2Icon.typePerformance]: PerformanceTypeShape,
    [Shape2Icon.typeDynamic]: DynamicTypeShape,
    [Shape2Icon.typeMobileContent]: MobileContentTypeShape,
    [Shape2Icon.typeMCBanner]: MCBannerTypeShape,
    [Shape2Icon.typeCPMBanner]: ImageAdTypeShape,
    [Shape2Icon.typeCPMAudio]: CPMAudioTypeShape,
    [Shape2Icon.typeCPMOutdoor]: CPMOutdoorTypeShape,
    [Shape2Icon.typeCPMBannerInMetro]: CPMBannerInMetroShape,
    [Shape2Icon.typeCPMIndoor]: CPMIndoorTypeShape,
    [Shape2Icon.typeCPMCampaign]: CPMBannerTypeShape,
    [Shape2Icon.typeCPMPriceCampaign]: CPMPriceTypeShape,
    [Shape2Icon.typeCPMDeals]: CPMDealsTypeShape,
    [Shape2Icon.typeImageAd]: ImageAdTypeShape,
    [Shape2Icon.magicWand]: MagicWandShape,
    [Shape2Icon.typeCPCVideo]: CPCVideoTypeShape,
    [Shape2Icon.typeContentPromotion]: ContentPromotionShape,
    [Shape2Icon.typeContentPromotionCollection]: ContentPromotionCollectionShape,
    [Shape2Icon.typeContentPromotionVideo]: ContentPromotionVideoShape,
    [Shape2Icon.typeCPMFrontpage]: CPMFrontpageTypeShape,
    [Shape2Icon.typeCPMGeoproduct]: CPMGeoproductTypeShape,
    [Shape2Icon.noImage]: NoImage,
    [Shape2Icon.noVideo]: NoVideo,
    [Shape2Icon.noAudio]: NoAudio,
    [Shape2Icon.doubleArrow]: DoubleArrow,
    [Shape2Icon.question]: Question,
    [Shape2Icon.smallRows]: SmallRows,
    [Shape2Icon.bigRows]: BigRows,
    [Shape2Icon.sort]: Sort,
    [Shape2Icon.feedback]: Feedback,
    [Shape2Icon.filter]: Filter,
    [Shape2Icon.dots]: Dots,
    [Shape2Icon.warning]: Warning,
    [Shape2Icon.closeBadge]: CloseBadge,
    [Shape2Icon.splitInfo]: SplitInfo,
    [Shape2Icon.bellShape]: BellShape,
    [Shape2Icon.share]: Share,
    [Shape2Icon.group]: Group,
    [Shape2Icon.long]: Long,
    [Shape2Icon.fullText]: FullText,
    [Shape2Icon.shortText]: ShortText,
    [Shape2Icon.mobile]: Mobile,
    [Shape2Icon.rsya]: RSYA,
    [Shape2Icon.short]: Short,
    [Shape2Icon.sidebarCampaigns]: SidebarCampaigns,
    [Shape2Icon.sidebarInfo]: SidebarInfo,
    [Shape2Icon.sidebarLibrary]: SidebarLibrary,
    [Shape2Icon.sidebarRecommendations]: SidebarRecommendations,
    [Shape2Icon.sidebarTools]: SidebarTools,
    [Shape2Icon.sidebarReports]: SidebarReports,
    [Shape2Icon.sidebarEdit]: SidebarEdit,
    [Shape2Icon.statusRunning]: StatusRunning,
    [Shape2Icon.statusPending]: StatusPending,
    [Shape2Icon.statusStopped]: StatusStopped,
    [Shape2Icon.statusStoppedOk]: StatusStoppedOk,
    [Shape2Icon.statusStoppedWarn]: StatusStoppedWarn,
    [Shape2Icon.statusPaused]: StatusPaused,
    [Shape2Icon.statusEnded]: StatusEnded,
    [Shape2Icon.sidebarReports]: SidebarReports,
    [Shape2Icon.outdoorBillBoard]: OutdoorBillBoard,
    [Shape2Icon.outdoorCitiFormat]: OutdoorCitiFormat,
    [Shape2Icon.outdoorMediaF]: OutdoorMediaF,
    [Shape2Icon.outdoorSuperSite]: OutdoorSuperSite,
    [Shape2Icon.outdoorDevice]: OutdoorDevice,
    [Shape2Icon.revert]: RevertShape,
    [Shape2Icon.refresh]: Refresh,
    [Shape2Icon.upload]: UploadShape,
    [Shape2Icon.location]: Location,
    [Shape2Icon.currentLocation]: CurrentLocation,
    [Shape2Icon.zoom]: ZoomShape,

    // Canvas icons
    [Shape2Icon.expand]: ExpandShape,
    [Shape2Icon.more]: MoreShape,
    [Shape2Icon.packshot]: PackshotShape,
    [Shape2Icon.trash]: Trash,
    [Shape2Icon.audioPause]: AudioPause,
    [Shape2Icon.audioPlay]: AudioPlay,
    [Shape2Icon.export]: ExportShape,

    // Touch icons
    [Shape2Icon.copyId]: CopyId
};

export interface Shape2Props {
    width: number;
    height: number;
    title?: string;
    theme?: Shape2Theme;
    tone?: Shape2Tone;
    hoverable?: boolean;
    disabled?: boolean;
    cls?: string;
    onClick?: (event: React.MouseEvent<HTMLSpanElement>) => void;
    icon: Shape2Icon;
    padding?: Shape2Padding;
}

export class Shape2 extends React.PureComponent<Shape2Props> {
    render() {
        const {
            width,
            height,
            title,
            theme = Shape2Theme.default,
            tone = Shape2Tone.dark,
            icon,
            hoverable = false,
            disabled = false,
            cls,
            padding
        } = this.props;

        const { id } = svgIcons[icon];

        return (
            <span
                title={title}
                className={classNames(
                    Bem.cls({
                        block: 'shape2-wrapper',
                        mods: { padding: padding ? padding : false }
                    }),
                    cls
                )}
                onClick={this.onClick}
            >
                <svg
                    className={Bem.cls({
                        block: 'shape2',
                        mods: { tone, theme, hoverable, disabled }
                    })}
                    style={{ width: `${width}px`, height: `${height}px` }}
                >
                    <use xlinkHref={`#${id}`} />
                </svg>
            </span>
        );
    }

    private onClick = (event: React.MouseEvent<HTMLSpanElement>) => {
        const { onClick } = this.props;

        if (onClick) {
            onClick(event);
        }
    };
}
